import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const BASE_URL = window.serverData.data.portalAPIURL;
const API_URL = window.serverData.data.apiBaseUrl;
const TermsFeatureId = window.serverData.data.termsAndConditionsFeatureId;

export const recompileProfile = (token) => {
    const fullUrl = `${BASE_URL}/api/membership/getrecompileprofile`;

    const params = {
        headers: {
            authorization: `bearer ${token}`
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Portal.ProfileRecompile.Get", start, fullUrl);
        return response.json();
    }).catch(err => {
        logAPI("MBHWeb.Api.Portal.ProfileRecompile.Get.Failure", start, fullUrl);
        return Promise.reject(err);
    });

};

/**
 * Returns search results for the site.
 * 
 * @param {any} searchphrase the words to search for
 * @param {any} token the user token
 * 
 * @returns {any} consent model
 */
export const search = (searchphrase, token) => {
    const fullUrl = `${BASE_URL}/api/sitesearch/search?SearchPhrase=${searchphrase}`;

    let params = {
        headers: {
            authorization: `bearer ${token}`
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Portal.SiteSearch.Search.Success", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Portal.SiteSearch.Search.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getPatientPhoto = (token, id, idType) => {
    const fullUrl = `${BASE_URL}/api/patient/getpatientphoto?id=${id}&idType=${idType}`;

    const params = {
        headers: {
            authorization: `bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    const start = new Date();

    return fetch(fullUrl, params).then(response => {
        logAPI("MBHWeb.Api.Portal.PatientPhoto.Get", start, fullUrl);
        return response.json();
    }).catch(err => {
        logAPI("MBHWeb.Api.Portal.PatientPhoto.Get.Failure", start, fullUrl);
        return Promise.reject(err);
    });
};

export const getThrive = (token) => {
    var start = new Date();
    const url = BASE_URL + '/Api/Thrive/GetThrive';
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Thrive.Visit.Redirect", start, url);
        return response;
    }).catch(err => {
        logAPI("MBHWeb.Api.Thrive.Visit.Redirect.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getEpicFluRecords = (token) => {
    const fullUrl = `${BASE_URL}/api/patient/flustatus`;

    let params = {
        headers: {
            authorization: `bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Portal.FluStatus.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Portal.FluStatus.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};


export const getCompleteFluStatus = (token) => {
    const fullUrl = `${BASE_URL}/api/patient/completeFluStatus`;

    if (window.serverData.data.enableFluVaccine) {
        let params = {
            headers: {
                authorization: `bearer ${token}`,
                "Cache-Control": "no-cache",
                "Pragma": "no-cache"
            },
            method: "GET"
        };

        var start = new Date();

        return fetch(fullUrl, params)
            .then(response => {
                logAPI("MBHWeb.Api.Portal.CompleteFluStatus.Get", start, fullUrl);
                return response.json();
            })
            .catch(err => {
                logAPI("MBHWeb.Api.Portal.CompleteFluStatus.Get.Failure", start, fullUrl);
                return Promise.reject(err);
            });
    }
    else {
        return Promise.reject(null);
    }
};


export const getPeopleSoftFluStatus = (token) => {
    const fullUrl = `${BASE_URL}/api/patient/PeopleSoftFluStatus`;

    if (window.serverData.data.enableFluVaccine) {
        let params = {
            headers: {
                authorization: `bearer ${token}`,
                "Cache-Control": "no-cache",
                "Pragma": "no-cache"
            },
            method: "GET"
        };

        var start = new Date();

        return fetch(fullUrl, params)
            .then(response => {
                logAPI("MBHWeb.Api.Portal.PeopleSoftFluStatus.Get", start, fullUrl);
                return response.json();
            })
            .catch(err => {
                logAPI("MBHWeb.Api.Portal.PeopleSoftFluStatus.Get.Failure", start, fullUrl);
                return Promise.reject(err);
            });
    }
    else {
        return Promise.reject(null);
    }
};


export const getTermsAndConditions = (userName, token) => {

    //debugger;
    if (userName === undefined || userName == "undefined") {
        userName = "";
    }
    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }
    var oBody = {};
    //debugger;
    if (userName != null && userName != "") {
        oBody["UserName"] = userName;
    }

    var url = null;
    var params = null;
    if (token != null && token != "") {
        oBody["featureId"] = TermsFeatureId;
        url = `${API_URL}/v2/HealthSource/TermsAndConditions/feature/${TermsFeatureId}`;
        params = {
            method: "GET",
            //body: JSON.stringify(oBody),
            headers: oHeaders,
        };
        var start = new Date();

        //debugger;  

        return fetch(url, params).then(response => {
            //debugger;                            
            logAPI("MBHWeb.Api.TermsConditions.ById.V2.Get", start, url);
            if (response.status >= 200 && response.status < 300) {
                return Promise.resolve(response.json());
            } else {
                //debugger;
                return Promise.reject(response);
            }
        }).then((data) => {
            //debugger;
            data = {
                id: data[0].Id,
                versionId: data[0].versionId ? data[0].versionId : data[0].VersionId,
                textToDisplay: data[0].textToDisplay ? data[0].textToDisplay : data[0].TextToDisplay,
                featureId: data[0].featureId ? data[0].featureId : data[0].FeatureId,
                isAccepted: data[0].isAccepted ? data[0].isAccepted : data[0].IsAccepted,
                isSuccessful: true,
                actualError: null,
                displayError: null
            }
            //debugger;
            return data;
        }).catch(e => {
            debugger;
            logAPI("MBHWeb.Api.TermsConditions.ById.V2.Get.Failure", start, url, e);
            return Promise.resolve({ id: 3, isAccepted: true, isSuccessful: false, statusCode: 0, versionId: 2 });
        }
        );

    }
    else {
        oBody["FeatureId"] = TermsFeatureId;
        url = `${BASE_URL}/TCC/FetchCurrent`;
        params = {
            method: "POST",
            body: JSON.stringify(oBody),
            headers: oHeaders,
        };
        var start = new Date();

        //debugger;  

        return fetch(url, params).then(response => {
            //debugger;                            
            logAPI("MBHWeb.Api.TermsConditions.ById.Get", start, url);
            if (response.status >= 200 && response.status < 300) {
                //debugger;           
                return Promise.resolve(response.json());
            } else {
                return Promise.reject(response);
            }
        }).catch(e => {
            //debugger;
            logAPI("MBHWeb.Api.TermsConditions.ById.Get.Failure", start, url, e);
            return Promise.resolve({ id: 3, isAccepted: true, isSuccessful: false, statusCode: 0, versionId: 2 });
        }
        );
    }

};


export const acceptTermsAndConditions = (token, userName, version) => {

    const url = `${BASE_URL}/TCC/AcceptCurrent`;

    const params = {
        method: "POST",
        body: JSON.stringify({ FeatureId: TermsFeatureId, UserName: userName, VersionId: version }),
        headers: {
            "Authorization": 'bearer ' + token,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
    };
    var start = new Date();

    //debugger;

    return fetch(url, params).then(response => {
        //debugger;
        logAPI("MBHWeb.Api.TermsConditions.Accept.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.TermsConditions.Accept.Post.Failure", start, url, err); return Promise.reject(err); });
};



export const getNotices = (userIsLoggedIn, hasMyChart, hasHealthPlan) => {
    const params = urlParams(
        'userIsLoggedIn', userIsLoggedIn, 'hasMyChart', hasMyChart, 'hasHealthPlan', hasHealthPlan
    );
    var start = new Date();
    const url = `${BASE_URL}/Api/Notices/GetNotices${params}`;
    return fetch2(url).then(response => {
        logAPI("MBHWeb.Api.Notifications.GetNotices", start, url);
        let notices = [];
        if (response && response.length > 0) {
            for (let i = 0; i < response.length; i++) {
                var noticeId = "notice_" + response[i].id;
                if (!localStorage.getItem(noticeId)) {
                    notices.push(response[i]);
                }
            }
        }
        return notices;
    }).catch(err => { logAPI("MBHWeb.Api.Notifications.GetNotices.Failure", start, url, err); return Promise.reject(err); });
};



/**
* getLatLongFromAdress
* @param {string} token = token
* @param {string} address = Address of the User 
* @returns {Promise} Latitude/Longitude JSON
 */
export const getLatLongFromAddress = (token, address) => {
    const url = `${BASE_URL}/api/location/GetLatLongFromAddress?address=${address}`;
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Authorization": 'bearer ' + token
        }
    };

    const request = new Request(url, params);
    var start = new Date();
    return fetch(request).then(response => {
        logAPI("MBHWeb.Api.Account.GetLatLongFromAdress", start, url);
        return Promise.resolve(response.json());
    }).catch(err => {
        //debugger;
        console.log(err);
        logAPI("MBHWeb.Api.Account.GetLatLongFromAdress.Failure", start, url, err);
        return Promise.reject(err);
    });
};


export const getAddressFromLatLong = (token, lat, lng) => {
    const uParams = urlParams(
        'lat', lat, 'lng', lng
    );
    const url = `${BASE_URL}/api/location/GetAddressFromLatLong${uParams}`;
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Authorization": 'bearer ' + token
        }
    };

    const request = new Request(url, params);
    var start = new Date();
    return fetch(request).then(response => {
        logAPI("MBHWeb.Api.Account.getAddressFromLatLong", start, url);
        return Promise.resolve(response.json());
    }).catch(err => {
        //debugger;
        console.log(err);
        logAPI("MBHWeb.Api.Account.getAddressFromLatLong.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const getAppUpdate = (token) => {
    var start = new Date();
    const url = '/tm/appUpdate';
    let params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
        },
        method: "GET"
    };
    return fetch2(url, params).then(response => {
        logAPI("MBHWeb.Api.GetAppUpdate", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.GetAppUpdate.Failure", start, url, err); return Promise.reject(err); });
};

/**
* getVideoVisitTermsAndConditions
* @param {string} userName = current userName
* @param {string} token = token
* @param {string} featureId = featureId of Terms (SameDayCare) 
* @param {string} proxyId = ProxyId
* @returns {Promise} Video Visit Terms
*/
export const getVideoVisitTermsAndConditions = (userName, token, featureId, proxyId) => {
    //debugger;
    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }

    const url = `${BASE_URL}/TCC/FetchCurrent`;
    const params = {
        method: "POST",
        body: JSON.stringify({ UserName: userName, FeatureId: featureId, ProxyId: proxyId }),
        headers: oHeaders
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.TermsConditions.VideoVisit.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch((e) => {
        logAPI("MBHWeb.Api.TermsConditions.VideoVisit.Get.Failure", start, url, e);
        return Promise.resolve({ id: 3, isAccepted: true, isSuccessful: false, statusCode: 0, versionId: 2 });
    }
    );
};

/**
* acceptVideoVisitTermsAndConditions
* @param {string} token = token
* @param {string} userName = current userName
* @param {string} version = terms version 
* @param {string} proxyId = ProxyId
* @returns {Promise} Video Visit Accept Terms
*/
export const acceptVideoVisitTermsAndConditions = (token, userName, version, proxyId) => {
    const url = `${BASE_URL}/TCC/AcceptCurrent`;
    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }

    const params = {
        method: "POST",
        body: JSON.stringify({
            UserName: userName, VersionId: version, ProxyId: proxyId, FeatureId: 'SameDayCare', IsAccepted: true
        }),
        headers: oHeaders
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.TermsConditions.VideoVisit.Accept.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.TermsConditions.VideoVisit.Accept.Post.Failure", start, url, err); return Promise.reject(err); });
};

export const getRoomStatuses = (token) => {
    const url = `${BASE_URL}/api/v1/video/GetRoomStatuses`;
    const params = {
        method: "GET",
        headers: {
            "Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        }
    };

    var start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetRoomStatuses", start, url);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetRoomStatuses.Failure", start, url, err);
            return Promise.reject(err);
        });
};

export const getConsumerJWT = (token, participantExternalId, participantName, csnId, epicExternalProviderId) => {
    const url = `${BASE_URL}/api/v1/video/ConsumerToken`;
    const postData = {
        participantId: participantExternalId,
        participantIdType: "External",
        participantRole: "Patient",
        participantName: participantName,
        csnId: csnId,
        epicExternalProviderId: epicExternalProviderId
    };

    const params = {
        method: "POST",
        headers: {
            "Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify(postData)
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetConsumerJWT.Failure", start, url, err);
            return Promise.reject(err);
        });

};



export const getTwilioConsumerJWT = (token, participantExternalId, participantName, csnId, epicExternalProviderId) => {
    const url = `${BASE_URL}/api/v2/video/ConsumerToken`;
    const postData = {
        participantId: participantExternalId,
        participantIdType: "External",
        participantRole: "Patient",
        participantName: participantName,
        csnId: csnId,
        epicExternalProviderId: epicExternalProviderId
    };

    const params = {
        method: "POST",
        headers: {
            "Authorization": `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        body: JSON.stringify(postData)
    };

    const start = new Date();

    return fetch(url, params)
        .then(resp => {
            logAPI("MBHWeb.Api.VideoVisit.GetTwilioConsumerJWT", start, url);
            return resp.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.VideoVisit.GetTwilioConsumerJWT.Failure", start, url, err);
            return Promise.reject(err);
        });

};

/**
* getVideoVisitTermsAndConditionsForSharedLink
* @param {string} featureId = featureId of Terms (SameDayCare) 
* @returns {Promise} Video Visit Terms
*/
export const getVideoVisitTermsAndConditionsForShareLink = (token, featureId) => {
    const url = `${BASE_URL}/TCC/GetTermsListForShareLink`;

    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }

    const params = {
        method: "POST",
        body: JSON.stringify({ FeatureId: featureId }),
        headers: oHeaders
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.VideoVisit.ShareLink.GetTermsAndConditionsList", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch((e) => {
        logAPI("MBHWeb.Api.VideoVisit.ShareLink.GetTermsAndConditionsList.Failure", start, url, e);
        return Promise.reject(e);
    }
    );
};

export const getVideoVisitTCStatusForShareLink = (token, shareLinkCode) => {
    const url = `${BASE_URL}/TCC/GetShareLinkTermsStatus?sharedLinkCode=${shareLinkCode}`;

    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }

    const params = {
        method: "GET",
        headers: oHeaders
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.VideoVisit.ShareLink.GetTermsAndConditionsStatus", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch((e) => {
        logAPI("MBHWeb.Api.VideoVisit.ShareLink.GetTermsAndConditionsStatus.Failure", start, url, e);
        return Promise.reject(e);
    }
    );
};

export const acceptVideoVisitShareLinkTC = (token, termsAndConditions, shareLinkCode) => {

    const url = `${BASE_URL}/TCC/AcceptShareLinkTermsAndConditions?sharedLinkCode=${shareLinkCode}`;

    if (token === undefined || token == "undefined" || token == "null") {
        token = "";
    }

    var oHeaders = {
        "Accept": "application/json",
        "Content-type": "application/json"
    };
    if (token != null && token != "") {
        oHeaders["Authorization"] = "bearer " + token;
    }

    const params = {
        method: "POST",
        body: JSON.stringify(termsAndConditions),
        headers: oHeaders,
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.VideoVisit.ShareLink.AcceptTermsAndConditions", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => { logAPI("MBHWeb.Api.VideoVisit.ShareLink.AcceptTermsAndConditions.Failure", start, url, err); return Promise.reject(err); });
};

/**
 * Get the list of consents for the user
 * 
 * @param {any} token the user token
 *
 * @returns {any} consent model
 */
export const getConsents = (token) => {
    const fullUrl = `${BASE_URL}/api/v1/idserver/consents`;

    //debugger;

    let params = {
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        method: "GET",
        withCredentials: false,
        mode: 'no-cors'
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Portal.IDServer.Consents.Success", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Portal.IDServer.Consents.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

/**
 * Get revoke specific consent for the user
 * 
 * @param {any} token the user token
 * @param {any} consent the consent to delete
 *
 * @returns {any} consent result
 */
export const deleteConsent = (token, consent) => {
    const fullUrl = `${BASE_URL}/api/v1/idserver/consents/delete?SubjectId=${consent.SubjectId}&Key=${consent.Key}`;

    //debugger;

    let params = {
        headers: {
            authorization: `bearer ${token}`,
            "Accept": "application/json",
            "Content-type": "application/json"
        },
        //body: JSON.stringify(consent),
        method: "POST",
        withCredentials: false,
        mode: 'no-cors'
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Portal.IDServer.Consents.Success", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Portal.IDServer.Consents.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getVideoVisitUrl = (token, userName, csn) => {
    const params = {
        headers: {
            authorization: `bearer ${token}`,
        },
        method: "GET",
    };
    var start = new Date();
    const url = `${API_URL}/v6/Epic/VideoVisitUrl/?userName=${userName}&csn=${csn}`;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.VideoVistUrl.Success", start, url);
        return response.json();
    }).catch(err => {
        logAPI("MBHWeb.Api.VideoVisitUrl.Failure", start, url, err);
        return Promise.reject(err);
    });
};